export default __webpack_public_path__ + "static/media/icr_terminos.448a5e41.svg";